import React from "react";
import { Select } from "antd";
import useAcademicTerms from "../hooks/useAcademicTerms";

export default function TermSelect({ defaultValue, value, onChange, width, extended }) {
  const termOptions = useAcademicTerms(extended);

  return (
    <Select
      showSearch
      defaultValue={defaultValue}
      value={value}
      options={termOptions}
      onChange={onChange}
      popupMatchSelectWidth={false}
      style={{ width: width || "100%" }}
    />
  );
}
